import LoggingService from 's2s-logging-service';
import { LocalStorageService } from 's2s-app-service';
import objectMerge from 'object-merge';

const contacts = (state, action)=>{
  LoggingService.getInstance().debug('CONTACTS arguments: state, action', state, action);
  if (typeof state === 'undefined') {
    let returnArray = [];
    const lsContacts = LocalStorageService.getData('contacts');

    if (lsContacts.data ){
      LoggingService.getInstance().debug('localStorage contacts', lsContacts );
      returnArray = lsContacts.data;
    }

    return returnArray;
  }

  switch (action.type) {
    case "RECEIVE_CONTACTS_DATA": {
        LoggingService.getInstance().debug('CONTACTS_DATA', action.payload);
        // Add contacts to localStorage
        LocalStorageService.setData('contacts', action.payload);

        // console.log('contacts reducer payload.... ', action.payload);
        // Replacing the whole contacts array with what we get from api...
        return action.payload;
    }

    case "ADD_CONTACT": {
      const newState = objectMerge({}, state);
      return newState.concat(action.payload.data);
    }

    case "DELETE_CONTACT": {
      const newState = objectMerge({}, state);
      const filteredState = newState.filter((contact)=>{
        return contact.uuid !== action.payload;
      });
      return filteredState;
    }

    case "UPDATE_CONTACT": {
      const newState = objectMerge({}, state);
      const filteredState = newState.filter((contact)=>{
        return contact.uuid !== action.payload.data.uuid;
      });
      return filteredState.concat(action.payload.data);
    }


    default:
      return state;
  }
};

export { contacts };



// WEBPACK FOOTER //
// ./src/reducers/contacts-reducer.js